/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_ChangesInputs */



/**
* | output |
* | --- |
* | "Preview Changes" |
*
* @param {Preview_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preview_changes = /** @type {((inputs?: Preview_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aperçu des modifications")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen in der Vorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima delle modifiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр изменений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de cambios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更のプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तनों का पूर्वावलोकन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização das alterações")
	return /** @type {LocalizedString} */ ("Preview Changes")
});